export function isAdmin () {
  return auth.me.role_id === $model.user.ROLE_ADMIN
}
